import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { UiModule } from '@app/ui';
import { UIState } from '@app/ui/states/ui.state';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ASSET_GROUP_GAP } from '../../services/assets-ui-service';
import { AssetKey, AssetsState } from '../../states/assets.state';
import { AssetDisplayComponent } from '../asset-display/asset-display.component';

@Component({
  selector: 'rk-logo-assets-section',
  templateUrl: './logo-assets-section.component.html',
  styleUrl: './logo-assets-section.component.scss',
  standalone: true,
  imports: [AsyncPipe, UiModule, AssetDisplayComponent, FontAwesomeModule, TranslatePipe],
})
export class LogoAssetsSectionComponent {
  @Select(UIState.isCreationProcess) isCreationProcess$: Observable<boolean>;
  @Select(AssetsState.logoURL) logoURL$: Observable<string>;
  @Select(AppConfigurationState.availableOnAndroidTV)
  availableOnAndroidTV$: Observable<boolean>;
  @Select(AssetsState.iconTvURL)
  iconTvURL$: Observable<string>;
  @Input() assetWidth = 200;
  assetGroupGap = ASSET_GROUP_GAP;

  @Output() readonly crop = new EventEmitter<AssetKey>();
  @Output() readonly replace = new EventEmitter<AssetKey>();

  onCrop(assetKey: AssetKey): void {
    this.crop.emit(assetKey);
  }

  onReplace(assetKey: AssetKey): void {
    this.replace.emit(assetKey);
  }
}
